export async function useValidateOuvidoriaTicket(ticket: string) {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_GW_SECURITY_ENTRANCE}/self-service-hub/v1/ouvidoria/validate/${ticket}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        cache: 'no-cache',
      },
    )

    const result: { validate: boolean } = await response.json()

    return {
      isTicketValid: result.validate,
    }
  } catch (error) {
    return { isTicketValid: false }
  }
}
